export default {
  namespaced: true,
  state: {
    items: [],
    _meta: {
      page: 1,
      totalCount: null,
      perPage: 20,
    },
    item: null,
  },
  actions: {
    list({ commit, rootGetters, dispatch }, payload) {
      rootGetters.axl.post('orders/api/order/list', { ...payload })
        .then((response) => {
          commit('setField', { name: 'items', value: response.data.data });
          // eslint-disable-next-line no-underscore-dangle
          commit('setField', { name: '_meta', value: response.data._meta });
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
    view({ commit, rootGetters, dispatch }, payload) {
      commit('setField', { name: 'item', value: null });
      rootGetters.axl.post('orders/api/order/view', { ...payload })
        .then((response) => {
          commit('setField', { name: 'item', value: response.data.item });
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
    async changeStatus({ rootGetters, dispatch }, payload) {
      await rootGetters.axl.post('orders/api/order/change-status', { ...payload })
        .then((response) => {
          if (response?.data?.msg) {
            dispatch('ShowInfo', response.data.msg, { root: true });
          }
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
    update({ rootGetters, dispatch }, payload) {
      rootGetters.axl.post('orders/api/order/update', { ...payload })
        .then((response) => {
          if (response?.data?.msg) {
            dispatch('HandleError', response.data.msg, { root: true });
          }
        })
        .catch((error) => {
          dispatch('HandleError', error, { root: true });
        });
    },
  },
  mutations: {
    setField(state, payload) {
      state[payload.name] = payload.value;
    },
  },
};
